import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getSpaServices = async (filter = {}) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/SpaService`, {
      headers: getAuthHeader(),
      params: filter
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching spa services:", error);
    throw error;
  }
};

export const saveSpaService = async (spaService) => {
  const response = await axios.post(`${BASE_URL}/api/SpaService`, spaService, {
    headers: getAuthHeader(),
  });
  return response.data;
};

// API to bulk import spa services
export const bulkImportSpaServices = async (spaServicesData) => {
  try {
    console.log("📤 API call - bulkImportSpaServices:", spaServicesData.length, "spa services");
    console.log("📤 Request payload (first item):", spaServicesData[0]);
    
    // Send the data as a JSON array directly, not wrapped in an object
    const response = await axios.post(`${BASE_URL}/api/SpaService/bulk-import`, spaServicesData, {
      headers: getAuthHeader(),
    });
    console.log("✅ API response - bulkImportSpaServices:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API error - bulkImportSpaServices:", error);
    console.error("❌ Error response:", {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message
    });
    throw error;
  }
};

// API to search spa services with pagination and search text
export const searchSpaServices = async (searchText, page = 1, pageSize = 20) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaService/search`, {
      searchText: searchText || "", // Convert null/undefined to empty string
      page: page,
      pageSize: pageSize,
      activeOnly: true
    }, {
      headers: getAuthHeader(),
    });
    
    return response.data;
  } catch (error) {
    console.error("❌ API Error - searchSpaServices:", error);
    console.error("❌ Error details:", {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error;
  }
};

// API to export spa services to Excel
export const exportSpaServicesToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaService/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SpaServiceReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting spa services:", error);
    throw error;
  }
};
